<template>
  <div class="flex h-full">
    <Slide
      :class="{ panel: true, 'sidebar-open': isOpen }"
      right
      width="350"
      disableOutsideClick
      :isOpen="isOpen"
      :burgerIcon="!isOpen"
      :crossIcon="false"
      @openMenu="isOpen = true"
      @closeMenu="isOpen = false"
    >
      <div id="close" v-if="isOpen" @click="isOpen = false">
        <svg fill="white" x="0px" y="0px" width="100%" height="100%" viewBox="0 0 512 512">
          <path
            d="M443.6,387.1L312.4,255.4l131.5-130c5.4-5.4,5.4-14.2,0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4 L256,197.8L124.9,68.3c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4L68,105.9c-5.4,5.4-5.4,14.2,0,19.6l131.5,130L68.4,387.1 c-2.6,2.6-4.1,6.1-4.1,9.8c0,3.7,1.4,7.2,4.1,9.8l37.4,37.6c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1L256,313.1l130.7,131.1 c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1l37.4-37.6c2.6-2.6,4.1-6.1,4.1-9.8C447.7,393.2,446.2,389.7,443.6,387.1z"
          ></path>
        </svg>
      </div>
      <sidebar />
    </Slide>
    <div id="content-container" :class="{ 'sidebar-open': isOpen }">
      <div class="container mx-auto h-full px-8 relative">
        <transition :name="transitionName" :mode="transitionMode">
          <router-view :key="$route.fullPath" id="router-cont" class="pt-6 pb-20" />
        </transition>
        <toolbar />
        <LegalModal />
        <ContactModal />
        <SubscribeModal />
        <DMModal name="educator">
          <p class="mb-4 text-lg">
            Want to educate with DesignMorphine?
          </p>
          <p class="mb-4">
            Send us an email to
            <a class="hover:text-dm" href="mailto:educate@designmorphine.com" target="_blank"
              >educate@designmorphine.com</a
            >
            containing the following images and information
          </p>
          <ul class="list-disc pl-6">
            <li>Your first and last name</li>
            <li>Description of what you want to teach</li>
            <li>3 images of what you want to teach</li>
          </ul>
        </DMModal>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Sidebar from './frontend/Sidebar';
import Toolbar from '@components/Toolbar';
import DMModal from '@components/DMModal';
import LegalModal from '@components/modals/LegalModal';
import { Slide } from 'vue-burger-menu';
import ContactModal from '@components/modals/ContactModal';
import SubscribeModal from '@components/modals/SubscribeModal';
import _ from 'lodash';

const DEFAULT_TRANSITION = 'route-fade';

export default {
  name: 'Client',

  data() {
    return {
      transitionName: DEFAULT_TRANSITION,
      transitionMode: '',
      open: false,
      isOpen: true,
    };
  },

  watch: {
    $route: function(to, from) {
      if (this.$store.state.screenSize < 3 && to.name !== 'search') {
        this.isOpen = false;
      }
    },
  },

  mounted() {
    this.$bus.$on('filter', () => {
      this.setIsOpen();
    });

    this.$bus.$on('section', () => {
      this.setIsOpen();
    });
  },

  created() {
    this.size();

    window.addEventListener('resize', _.debounce(this.size, 500));

    this.$router.beforeEach((to, from, next) => {
      this.$bus.$off('scrollDown');

      let transitionName = to.meta.transitionName;
      let transitionMode = 'out-in';

      if (transitionName === 'slide' && from.meta.transitionName === 'slide') {
        transitionName = to.meta.index >= from.meta.index ? 'slide-down' : 'slide-up';
        transitionMode = '';
      }

      if (to.meta.index === -1) {
        transitionName = 'slide-left';
      }

      this.transitionName = transitionName || DEFAULT_TRANSITION;
      this.transitionMode = transitionMode;
      next();
    });
  },

  components: {
    SubscribeModal,
    ContactModal,
    LegalModal,
    DMModal,
    sidebar: Sidebar,
    toolbar: Toolbar,
    Slide,
  },

  methods: {
    size() {
      const width = window.innerWidth;
      this.setScreenSize(this.screenSize(width));
      this.setIsOpen();
    },
    screenSize(width) {
      if (width < 475) {
        return 1;
      }

      if (width >= 475 && width < 1024) {
        return 2;
      }

      if (width >= 1024 && width < 2000) {
        return 3;
      }

      return 4;
    },
    setIsOpen() {
      if (this.$store.state.screenSize < 3) {
        this.isOpen = false;
      } else if (this.isOpen === false) {
        this.isOpen = true;
      }
    },
    ...mapActions({
      setUser: 'setUser',
      setScreenSize: 'setScreenSize',
    }),
  },

  computed: {
    ...mapGetters({
      user: 'getUser',
    }),
  },
};
</script>
<style lang="scss">
#content-container {
  flex-grow: 1;
  transition: margin-right 0.5s linear;

  @media screen and (min-width: 992px) {
    &.sidebar-open {
      margin-right: 350px;
    }
  }

  @media screen and (max-width: 992px) {
    .bm-menu {
      background: rgba(0, 0, 0, 0.97) !important;
    }
  }

  @media screen and (max-width: 600px) {
    .container {
      padding: 0 1rem !important;

      & > div:first-child {
        padding-top: calc(1rem - 0.45rem);

        & > h1 {
          padding-right: 15% !important;
        }
      }
    }
  }
}

#close {
  padding: 0 !important;
  position: absolute;
  width: 36px;
  height: 36px;
  right: 1rem !important;
  top: calc(1.5rem - 2px) !important;
  cursor: pointer;

  @media screen and (min-width: 977px) {
    right: 2rem !important;
  }
}

.route-fade-enter-active,
.route-fade-leave-active {
  transition-duration: 0.5s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.route-fade-enter,
.route-fade-leave-active {
  opacity: 0;
}

.slide-down-enter-active,
.slide-down-leave-active,
.slide-up-enter-active,
.slide-up-leave-active {
  transition-duration: 0.3s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
  overflow: hidden;
}

.slide-down-enter,
.slide-up-leave-active {
  opacity: 0;
  position: absolute;
  width: calc(100% - 4rem);

  #main {
    width: calc(65% + 2.5rem);
  }

  transform: translateY(50%);
}

.slide-down-leave-active,
.slide-up-enter {
  opacity: 0;
  position: absolute;
  width: calc(100% - 4rem);

  #main {
    width: calc(65% + 2.5rem);
  }

  transform: translateY(-50%);
}

.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity, transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
  overflow: hidden;
}

.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  position: absolute;
  width: calc(100% - 4rem);

  #main {
    width: calc(65% + 2.5rem);
  }

  transform: translateX(50%);
}

.slide-right-leave-active,
.slide-left-enter {
  opacity: 0;
  position: absolute;
  width: calc(100% - 4rem);

  #main {
    width: calc(65% + 2.5rem);
  }

  transform: translateX(-50%);
}

#router-cont {
  height: 100%;
}

.panel {
  z-index: 1 !important;

  @media screen and (max-width: 500px) {
    z-index: 100 !important;
  }
}

@media screen and (max-width: 400px) {
  .panel {
    width: 0 !important;

    &.sidebar-open {
      .bm-menu {
        width: 100% !important;
      }
    }

    &:not(.sidebar-open) {
      .bm-menu {
        width: 0 !important;
      }
    }
  }
}

.bm-burger-button {
  position: fixed;
  width: 36px;
  height: 30px;
  right: 1rem !important;
  top: 1rem !important;

  @media screen and (min-width: 1000px) {
    right: 2rem !important;
    top: 2rem !important;
  }

  cursor: pointer;
  z-index: 1200;
}

.bm-burger-bars {
  background-color: #fff;
}

.line-style {
  position: absolute;
  height: 20%;
  left: 0;
  right: 0;
}

#slide-panel:not(.slider-open) .bm-menu {
  width: 0 !important; /* 0 width - change this with JavaScript */
}

.bm-menu {
  height: 100%; /* 100% Full-height */
  position: fixed; /* Stay in place */
  z-index: 10 !important; /* Stay on top */

  @media screen and (max-width: 992px) {
    background: rgba(0, 0, 0, 0.97) !important;
  }

  @media screen and (min-width: 992px) {
    background-color: transparent !important;
  }

  overflow-x: hidden; /* Disable horizontal scroll */
  padding-top: 5rem; /* Place content 60px from the top */
  transition: 0.5s; /*0.5 second transition effect to slide in the sidenav*/
}

.bm-overlay {
  background: rgba(0, 0, 0, 0.9);
}

.bm-item-list {
  color: white !important;
  margin-left: 0 !important;
  font-size: 0.875rem;
  height: 100%;
}

.bm-item-list > * {
  display: flex;
  text-decoration: none;
  padding: 0 2rem 0 0 !important;

  @media screen and (max-width: 1024px) {
    padding: 0 1rem 0 !important;
  }
}

.bm-item-list > * > span {
  margin-left: 10px;
  font-weight: 700;
  color: white;
}

@media screen and (max-width: 500px) {
  .lightbox-next span,
  .lightbox-prev span {
    display: none;
  }
}
</style>
